export default __webpack_public_path__ + "static/HelveticaNeueLTStd-Roman-9a81b6f1e94a536bf04358dba58976ba.woff2";